import { AccountService } from '@/services';

const TYPE = {
        RAW: 'RAW',
        KPI: 'KPI',
    },
    { RAW, KPI } = TYPE;
const TYPES = [RAW, KPI];

export default {
    namespaced: 'true',
    state: getDefaultState(),
    mutations: {
        setVisible(state, value) {
            state.visible = value;
        },
        setFileList(state, value = []) {
            state.fileList = R.zipObj(TYPES, value);
        },
    },
    actions: {
        fetchFileList({ commit }, { accountId }) {
            const apis = TYPES.map((type) => {
                const api =
                    type === 'KPI'
                        ? AccountService.getKpiData
                        : AccountService.getRawData;
                return api(accountId);
            });

            return Promise.all(apis).then((data = []) => {
                commit('setFileList', data);
            });
        },
    },
    getters: {},
};

function getDefaultState() {
    return {
        visible: false,
        fileList: {
            RAW: [],
            KPI: [],
        },
    };
}
